import * as React from 'react';
import { INewBuildingPromo } from '../../types/newBuldings/promo';
import { Promo } from './components/Promo';
import * as styles from './PromoBlock.css';

interface IPromoBlockProps {
  onPromoClick?(promo: INewBuildingPromo): void;
  onPromoHover?(promo: INewBuildingPromo): void;
  promos: INewBuildingPromo[];
  url: string;
}

export const PromoBlock: React.FC<IPromoBlockProps> = ({ onPromoClick, onPromoHover, promos, url }) => {
  const displayPromos = React.useMemo(() => [...promos].reverse(), [promos]);

  const handlers = React.useMemo(
    () =>
      displayPromos.map(promo => ({
        handleClick: onPromoClick ? () => onPromoClick(promo) : undefined,
        handleHover: onPromoHover ? () => onPromoHover(promo) : undefined,
      })),
    [displayPromos, onPromoClick, onPromoHover],
  );

  return (
    <div className={styles['container']}>
      {displayPromos.map((promo, index) => (
        <Promo
          key={promo.promoType}
          promoType={promo.promoType}
          newBuildingLabel={promo.newBuildingLabel}
          url={url}
          onClick={handlers[index].handleClick}
          onHover={handlers[index].handleHover}
        />
      ))}
    </div>
  );
};
